import { MagnifyingGlass, X } from "@phosphor-icons/react";

/**
 * SearchBar — unified search input used across NYLSU list pages.
 * Client-side filtering assumes the list is already loaded (≤5k rows).
 */
export default function SearchBar({
  value,
  onChange,
  placeholder = "Search…",
  filters,        // optional React node rendered inline
  resultCount,    // optional number to display
  testId,
}) {
  return (
    <div className="mb-6 border" style={{ borderColor: "var(--nylsu-border)", background: "var(--nylsu-card)" }}
         data-testid={testId || "searchbar"}>
      <div className="flex items-center gap-3 px-4 py-3 border-b" style={{ borderColor: "var(--nylsu-border)" }}>
        <MagnifyingGlass size={16} weight="light" className="text-[#8F8D84]" />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent outline-none text-sm"
          data-testid={testId ? `${testId}-input` : "searchbar-input"}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="p-1 text-[#8F8D84] hover:text-[#0A0A0A]"
            data-testid={testId ? `${testId}-clear` : "searchbar-clear"}
            aria-label="clear"
          >
            <X size={14} weight="light" />
          </button>
        )}
        {resultCount != null && (
          <div className="text-[10px] uppercase tracking-[0.15em] text-[#8F8D84]"
               data-testid={testId ? `${testId}-count` : "searchbar-count"}>
            {resultCount}
          </div>
        )}
      </div>
      {filters && (
        <div className="flex flex-wrap items-center gap-3 px-4 py-3 text-xs">
          {filters}
        </div>
      )}
    </div>
  );
}

/** Simple case-insensitive filter helper for list pages. */
export function textMatch(needle, ...haystacks) {
  const n = (needle || "").trim().toLowerCase();
  if (!n) return true;
  return haystacks.some((h) => (h || "").toString().toLowerCase().includes(n));
}
